import axios from 'axios';
import Promise from 'promise-polyfill';
import i18n from '../../translations';

const isValidProperty = property => property != null && property.length > 1;

const formatToUpperCase = str => str.replace(/(?:^|\.?)([A-Z])/g, (x, y) => `_${y.toUpperCase()}`).replace(/^_/, '').toUpperCase();

const trimHostPath = (str) => {
	while (str[str.length - 1] === '/') {
		str = str.substr(0, str.length - 1);
	}
	return str;
};

const trimRoutePath = (str) => {
	while (str[0] === '/') {
		str = str.substr(1, str.length);
	}
	return str;
};

export class CentiosConfiguration {
	constructor(hostNames) {
		this.hosts = [];
		this.routes = [];

		// Array
		if (Array.isArray(hostNames)) {
			hostNames.forEach((host) => {
				if (typeof host === 'string') {
					this.hosts.push({ name: host, path: host });
				} else if (!Array.isArray(host) && typeof host === 'object'
					&& isValidProperty(host.name) && isValidProperty(host.path)) {
					if (host.path[0] === '$') {
						const pathKey = host.path.substr(1);
						const envPath = process.env[pathKey];
						if (envPath == null) {
							throw new Error(`Environement variable '${pathKey}' wasn't found in .env file.`);
						}
						host.path = envPath;
					}
					this.hosts[host.name] = trimHostPath(host.path);
					if (isValidProperty(host.routes) && Array.isArray(host.routes)) {
						host.routes.forEach((route) => {
							if (isValidProperty(route.name) && isValidProperty(route.path)) {
								const name = `${host.name.toUpperCase()}_${formatToUpperCase(route.name)}`;
								if (this.routes[name] != null) {
									throw new Error(`Route '${route.name}' from host '${host.name}' has already been registerd.`);
								}
								this.routes[name] = trimRoutePath(route.path);
							} else {
								throw new Error(`Route '${route.name}' is not a valid route`);
							}
						});
					} else {
						throw new Error(`Host ${host.name} doesn't have any routes.`);
					}
				} else {
					throw new Error(`Error while parsing host ${host}`);
				}
			});
		} else if (typeof hostNames === 'string') {
			this.hosts.push({ name: 'default', path: hostNames });
		}
	}
}

export class Centios {
	/**
   * @param {CentiosConfiguration} config Configuration containing the hosts and routes.
   */
	constructor(config) {
		if (config == null) {
			throw new Error('CentiosConfiguration is required to create a Centios instance');
		}
		this.config = config;
	}

	post(name, data, headers) {
		return new Promise((resolve, reject) => {
			if (!isValidProperty(name) || name.indexOf('_') === -1 || !this.config.routes[name]) {
				throw new Error(`Unknown route ${name}`);
			}
			const route = this.config.routes[name];
			const url = `${this.config.hosts[name.substr(0, name.indexOf('_'))]}/${route}`;
			return axios.post(url, data, {
				headers: {
					'X-localization': i18n.locale,
					...headers,
				},
			}).then(resolve).catch(reject);
		});
	}
}
